import { render, staticRenderFns } from "./sessions.vue?vue&type=template&id=a89fea56&scoped=true&"
import script from "./sessions.vue?vue&type=script&lang=js&"
export * from "./sessions.vue?vue&type=script&lang=js&"
import style0 from "./sessions.vue?vue&type=style&index=0&id=a89fea56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89fea56",
  null
  
)

export default component.exports